import React from 'react';

import { AppImage } from 'src/shared/components';

import { Typography } from 'src/shared/components/ui';

interface ProductNameCellProps {
  name: string;
  image: string | null;
  id: string;
}

const ProductNameCell: React.FC<ProductNameCellProps> = ({
  name,
  image,
  id
}) => {
  return (
    <div className="flex gap-2 items-center">
      <AppImage
        className="size-12 object-cover min-w-12 rounded-xl bg-gray-2 border border-gray-4"
        id={id}
        src={image ?? undefined}
        alt={name}
      />
      <Typography variant="body-1" weight="bold">
        {name}
      </Typography>
    </div>
  );
};

export default ProductNameCell;
